import { BooleanInput } from "@/components/admin/boolean-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { email, required, useGetIdentity, useRecordContext } from "ra-core";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const isSelf = record?.id === identity?.id;

  return (
    <div className="space-y-4 w-full">
      {/* Basic Info */}
      <div className="grid grid-cols-2 gap-4">
        <TextInput source="first_name" validate={required()} helperText={false} />
        <TextInput source="last_name" validate={required()} helperText={false} />
      </div>
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <TextInput source="phone" helperText={false} />

      {/* Role & Department */}
      <div className="border-t pt-4 mt-2">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-3">
          System Access &amp; HR
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Roles are fetched from the `roles` table in the DB — not hardcoded */}
          <ReferenceInput source="role" reference="roles">
            <SelectInput
              optionText="name"
              optionValue="slug"
              helperText="System access level"
              readOnly={isSelf}
              label="System Role"
            />
          </ReferenceInput>

          {/* HR Department */}
          <ReferenceInput source="department_id" reference="hr_departments">
            <SelectInput
              optionText="name"
              optionValue="id"
              helperText="HR Module"
              label="Department"
            />
          </ReferenceInput>

          {/* HR Designation */}
          <ReferenceInput source="designation_id" reference="hr_designations">
            <SelectInput
              optionText="title"
              optionValue="id"
              helperText="HR Module"
              label="Designation"
            />
          </ReferenceInput>
        </div>
      </div>

      {/* Account Options */}
      <div className="border-t pt-4 mt-2">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-3">
          Account Status
        </p>
        <div className="flex gap-6">
          <BooleanInput
            source="disabled"
            readOnly={isSelf}
            helperText={false}
          />
        </div>
      </div>
    </div>
  );
}
